import type { Persona } from "@shopify-harness/sdk";

/**
 * スタブモード（VITE_API_MODE=stub）とテストで使うペルソナのフィクスチャ。
 * 実運用では Claude Code が MCP の upsert_persona で D1 に投入したデータが表示される。
 */
export const personasFixture: Persona[] = [
  {
    id: "persona-1",
    shopDomain: "analytical-engine.myshopify.com",
    name: "堅実なリピーター佐藤さん",
    tagline: "月1回、決まったものを買い足す安定顧客",
    summary:
      "消耗品を定期的に買い足す30代。セールよりも在庫の確実さと配送の速さを重視する。\nメールのリンクから最短で購入を済ませる合理派で、レビューはあまり書かないが解約もしない。",
    segment: "RFM上位20%",
    quote: "いつもの商品が切れる前に届くと助かる",
    demographics: ["30代", "都市部在住", "共働き世帯"],
    goals: ["買い忘れをなくしたい", "手間なく定期的に補充したい"],
    painPoints: ["欠品時に代替品を探すのが面倒", "再入荷の告知に気づけない"],
    behaviors: ["月1回の定期的な購入", "メールのリンクから直接購入", "購入品目がほぼ固定"],
    preferredChannels: ["メール"],
    evidence: [
      "直近6ヶ月で毎月1回以上購入する顧客が124人",
      "この層の平均注文単価は全体平均の1.4倍",
      "再入荷通知の登録率が他セグメントの2.1倍"
    ],
    contactCount: 124,
    revenueShare: 38.5,
    recommendation:
      "購入周期が安定しているため、追加獲得よりも「切らさない体験」への投資が最も効率的。RFM上位セグメントに固定して優遇し、購入周期に同期したリマインドで購入の手間を取り除くと LTV がさらに伸びる。",
    recommendedActions: [
      "セグメント『RFM上位20%』に割り当てて配信対象を固定する",
      "購入後フォローシナリオに30日周期の補充リマインドステップを追加する",
      "欠品時の機会損失を防ぐため、再入荷通知の登録を購入完了メールで案内する"
    ],
    status: "active",
    generatedBy: "claude-fable-5",
    createdAt: "2026-07-10T00:00:00.000Z",
    updatedAt: "2026-07-15T00:00:00.000Z"
  },
  {
    id: "persona-2",
    shopDomain: "analytical-engine.myshopify.com",
    name: "セール待ちの新規探索者",
    tagline: "値下げ通知で動く比較検討層",
    summary: "初回購入前後の価格感度が高い層。閲覧は多いがカート放棄率も高い。",
    segment: null,
    quote: null,
    demographics: [],
    goals: [],
    painPoints: [],
    behaviors: [],
    preferredChannels: [],
    evidence: [],
    contactCount: null,
    revenueShare: null,
    recommendation: null,
    recommendedActions: [],
    status: "draft",
    generatedBy: null,
    createdAt: "2026-07-12T00:00:00.000Z",
    updatedAt: "2026-07-12T00:00:00.000Z"
  },
  {
    id: "persona-3",
    shopDomain: "analytical-engine.myshopify.com",
    name: "ギフト目的の年2回顧客",
    tagline: "記念日に高単価商品をまとめ買いする贈答層",
    summary:
      "母の日・年末に集中して購入する層。自分用ではなく贈答用のため、ラッピングと配送日時指定を重視する。\n購入頻度は低いが1回あたりの単価が高く、時期が読めるためカレンダー起点の施策と相性が良い。",
    segment: "季節性・贈答",
    quote: "包装がきれいだとそれだけで安心する",
    demographics: ["40〜50代", "地方在住比率が高い"],
    goals: ["失敗しない贈り物を短時間で選びたい"],
    painPoints: ["配送日時の指定が分かりにくい", "のし・ラッピングの選択肢が探しにくい"],
    behaviors: ["5月と12月に購入が集中", "ギフトカテゴリのみ回遊", "客単価は通常層の2.3倍"],
    preferredChannels: ["メール", "LINE"],
    evidence: [
      "年2回のみ購入する顧客が86人、うち9割がギフトカテゴリ",
      "5月・12月の売上の31%をこの層が占める"
    ],
    contactCount: 86,
    revenueShare: 17.2,
    recommendation:
      "購入時期が5月・12月に集中しており、カレンダー起点の施策と相性が良い。需要期の1ヶ月前からの先回り案内で、贈答需要を確実に取り込む。",
    recommendedActions: [
      "セグメント『季節性・贈答』に割り当てて通常のセール配信から分離する",
      "母の日・年末に向けたシーズン切替シナリオ（需要期1ヶ月前起動）を追加する",
      "ギフト包装・のし・配送日時指定を案内するステップを購入前フローに追加する"
    ],
    status: "active",
    generatedBy: "claude-fable-5",
    createdAt: "2026-07-11T00:00:00.000Z",
    updatedAt: "2026-07-14T00:00:00.000Z"
  },
  {
    id: "persona-4",
    shopDomain: "analytical-engine.myshopify.com",
    name: "休眠したかつてのVIP",
    tagline: "半年前まで上位だったが購入が止まった要注意層",
    summary:
      "1年前はRFM上位だったが、直近6ヶ月の購入がない層。競合への流出か生活変化が想定される。\n保有コスト0円のリストとして持ち続け、掘り起こしフローの主対象とする。",
    segment: "休眠・元VIP",
    quote: null,
    demographics: ["購入履歴10回以上", "最終購入から180日以上"],
    goals: ["また信頼できる定番を見つけたい（推定）"],
    painPoints: ["離脱理由が不明（アンケート未実施）"],
    behaviors: ["メール開封はあるがクリックなし", "セール通知にも無反応"],
    preferredChannels: ["メール（開封のみ）"],
    evidence: ["Recency 180日超かつ累計購入10回以上の顧客が42人"],
    contactCount: 42,
    revenueShare: 0,
    recommendation:
      "過去の購買実績が大きく、復帰時の期待価値が高い。通常配信を続けても反応がないため、専用の掘り起こしフローに切り替えて再接点をつくる。",
    recommendedActions: [
      "セグメント『休眠・元VIP』に割り当てて通常配信から除外する",
      "休眠掘り起こしシナリオ（段階的クーポン強化つき）を適用する",
      "それでも無反応が続く場合は配信抑制リストへ移し、到達率を保護する"
    ],
    status: "archived",
    generatedBy: "claude-fable-5",
    createdAt: "2026-07-05T00:00:00.000Z",
    updatedAt: "2026-07-08T00:00:00.000Z"
  }
];
